import { addToEpiCart, removeFromEpiCart } from './utils/cart-utils';
import { addTooltipsOnPageLoad } from './modules/tooltips';
import { addToOrderLine, captureScreenDimensions } from './utils/sst-utils';
import { getParameterByName } from './utils/url-utils';
import { getPromoPopup } from './modules/site-popups/promo-popup';
import { getValueById } from './utils/html-utils';
import { initContentToggle } from './modules/content-toggle';
import { initMiniCart } from './modules/mini-cart';

import * as FormValidationUtils from './utils/form-validation-utils';
import * as GaEcommerceEvent from './utils/ga-ecommerce-utils';

import AutopopulateZipCode from './modules/autopopulate-zipcode';
import DesktopNavMenus from './modules/desktop-nav-menus';
import FilterToggle from './modules/filter-toggle';
import FixedMenu from './modules/fixed-menu';
import GridSliders from './modules/grid-sliders';
import HeaderSearch from './modules/header-search';
import InPageNav from './modules/in-page-nav';
import MobileNav from './modules/mobile-nav';
import OriginCookie from './modules/origin-cookie';
import PhoneDetection from './modules/phone-detection';
import SiteModal from './modules/site-modal';
import SitePopups from './modules/site-popups';
import SiteToaster from './modules/site-toaster';
import StickySidebar from './modules/sticky-sidebar';
import TabRole from './modules/accessibility/tab-role';
import VideoModal from './modules/video-modal';

window.FormValidationUtils = FormValidationUtils;
window.gaEcommerceEvent = GaEcommerceEvent;
window.SiteModal = SiteModal;
window.SiteToaster = SiteToaster;
window.StickySidebar = StickySidebar;
window.addToEpiCart = addToEpiCart;
window.addTooltipsOnPageLoad = addTooltipsOnPageLoad;
window.addToOrderLine = addToOrderLine;
window.getParameterByName = getParameterByName;
window.getPromoPopup = getPromoPopup;
window.getValueById = getValueById;
window.removeFromEpiCart = removeFromEpiCart;

AutopopulateZipCode();
DesktopNavMenus();
FilterToggle();
FixedMenu({
  offsetDiv: document.querySelector('.header'),
  menuDiv: document.querySelector('.primary-nav-wrapper'),
});
GaEcommerceEvent.init();
GridSliders();
HeaderSearch();
InPageNav();
// For A/B testing optimized header when there could be potentially 2 mobile nav wrappers
const mobileHeaderDivList = document.querySelectorAll('.nav-wrapper-mobile');
[...mobileHeaderDivList].forEach((mobileHeaderDiv) => {
  MobileNav({ mobileHeaderDiv });
});
OriginCookie();
PhoneDetection();
SitePopups();
TabRole();
VideoModal();

addTooltipsOnPageLoad();
captureScreenDimensions();
initContentToggle();
initMiniCart();
